import React, { Component } from 'react';
import { FormGroup, Input } from 'reactstrap';
import selectArrow from 'images/select-arrow.svg';

class PhoneSelect extends Component {
  render() {
    const { classSelect, idSelect, labelText, options } = this.props;

    return (
      <FormGroup className="flex">
        {labelText && <div className="text text-300 m-r-15">{labelText}</div>}
        <div className="select-wrap outline">
          <Input
            type="select"
            className={classSelect}
            name={idSelect}
            id={idSelect}
            onChange={this.props.onChange}
            value={this.props.value}>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
          <div className="select-wrap__icon">
            <img src={selectArrow} alt="" />
          </div>
        </div>
      </FormGroup>
    );
  }
}

export default PhoneSelect;



// WEBPACK FOOTER //
// ./src/components/PhoneSelect/PhoneSelect.js